import { Injectable, signal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AlbumDrawerService {
  readonly activeAlbumId = signal<string | null>(null);
  readonly isOpen = computed(() => this.activeAlbumId() !== null);

  /**
   * Open the preview drawer for the given album ID.
   */
  open(albumId: string | number): void {
    const resolved = String(albumId).trim();
    if (resolved) {
      this.activeAlbumId.set(resolved);
    }
  }

  /**
   * Close the preview drawer.
   */
  close(): void {
    this.activeAlbumId.set(null);
  }
}
